import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogActions, DialogContent, Typography } from "@mui/material";
import { useEffect, useRef } from "react";

export interface SimpleInfoModalProps {
  open: boolean;
  title: string;
  onClose: (value: boolean) => void;
  textInfo: string;
}

const InfoModal = (props: SimpleInfoModalProps) => {
  const { onClose, open, textInfo, title } = props;
  const dialogRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (open && dialogRef.current) {
      dialogRef.current.focus(); // Set focus to the modal when it opens
    }
  }, [open]);

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      open={open}
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: "20px",
          overflow: "hidden",
        },
      }}
      ref={dialogRef}
      aria-labelledby="info-modal-title"
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 1,
          backgroundColor: "primary.main",
          color: (theme) => theme.palette.grey[50],
          textAlign: "center",
        }}
        id="info-modal-title"
      >
        {title}
      </DialogTitle>
      <DialogContent dividers>
        <Typography
          variant="h5"
          sx={{
            typography: { xs: "h5", sm: "h5", md: "h5", lg: "h5" },
          }}
        >
          {textInfo}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose} size="small">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InfoModal;
